import _classCallCheck from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 36px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 16px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  font-weight: ", ";\n  padding: 20px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: 40px;\n  padding: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  height: 40px;\n  justify-content: space-between;\n  line-height: 40px;\n  text-align: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { Component } from 'react';
import styled from 'styled-components';
import { formatDate } from '@scp/ui-shared/core/utils';
import { color, typography } from '@scp/ui-shared/theme/variables';
import { Icon } from '@scp/ui-shared/theme/icons';
import { IconButton } from '@scp/ui-shared/components/buttons';
import moment from 'moment';
var TEXT = {
  PREV_TITLE: 'Previous Month',
  NEXT_TITLE: 'Next Month'
};
var MonthDisplay = styled.div(_templateObject());
var ActiveMonth = styled.div(_templateObject2(), color.textSecondary, typography.fontWeightSemiBold);
var NavigationButton = styled(IconButton)(_templateObject3());
var ValueDisplay = styled.div(_templateObject4(), color.palette.grey400, typography.fontWeightSemiBold);
var SelectedYear = styled.div(_templateObject5(), color.palette.grey800);
var SelectedDate = styled.div(_templateObject6(), color.palette.white);
/**
 * CalendarHeader is used by Calendar
 *
 * @example ./__docs__/CalendarHeader.md
 */

export var CalendarHeader = /*#__PURE__*/function (_Component) {
  _inherits(CalendarHeader, _Component);

  var _super = _createSuper(CalendarHeader);

  function CalendarHeader() {
    var _this;

    _classCallCheck(this, CalendarHeader);

    _this = _super.apply(this, arguments);

    _this.handleNextClick = function () {
      var onNextClick = _this.props.onNextClick;
      onNextClick();
    };

    _this.handlePreviousClick = function () {
      var onPreviousClick = _this.props.onPreviousClick;
      onPreviousClick();
    };

    return _this;
  }

  _createClass(CalendarHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          month = _this$props.month,
          fromMonth = _this$props.fromMonth,
          toMonth = _this$props.toMonth,
          selectedDay = _this$props.selectedDay,
          _this$props$showSelec = _this$props.showSelectedValue,
          showSelectedValue = _this$props$showSelec === void 0 ? true : _this$props$showSelec;
      var isMinMonth = !!fromMonth && moment(month).isSame(fromMonth, 'month');
      var isMaxMonth = !!toMonth && moment(month).isSame(toMonth, 'month');
      return React.createElement(React.Fragment, null, showSelectedValue && React.createElement(ValueDisplay, null, React.createElement(SelectedYear, null, formatDate(selectedDay, {
        format: 'year'
      })), React.createElement(SelectedDate, null, formatDate(selectedDay, {
        format: 'longWithoutYear'
      }))), React.createElement(MonthDisplay, null, React.createElement(NavigationButton, {
        title: TEXT.PREV_TITLE,
        onClick: this.handlePreviousClick,
        disabled: isMinMonth
      }, React.createElement(Icon, {
        name: "keyboard-arrow-left"
      })), React.createElement(ActiveMonth, {
        "data-testid": "active-month"
      }, formatDate(month, {
        format: 'monthAndYear'
      })), React.createElement(NavigationButton, {
        title: TEXT.NEXT_TITLE,
        onClick: this.handleNextClick,
        disabled: isMaxMonth
      }, React.createElement(Icon, {
        name: "keyboard-arrow-right"
      }))));
    }
  }]);

  return CalendarHeader;
}(Component);